import { MenuDTO } from '../../system/system-dtos';

export class SubNavDef {
  label: string;
  code: string;
  tabs: TabDef[];
}

export class TabDef {
  label: string;
  code: string;
  menuItem?: MenuDTO;
}

export const NAVIGATION_DEFINITION: SubNavDef[] = [
  {
    label: 'Bonuses',
    code: 'bonuses',
    tabs: [
      { label: 'Manage', code: 'bonuses' },
      { label: 'Diagnostics', code: 'PlayerBonuses' },
      { label: 'Targeting', code: 'BonusTargeting' },
    ],
  },
  {
    label: 'Free spins',
    code: 'free-spins',
    tabs: [
      { label: 'Manage', code: 'FreeSpinsControl' },
      { label: 'Diagnostics', code: 'report-free-spin' },
    ],
  },
  {
    label: 'Diagnostics',
    code: 'players-diagnostics',
    tabs: [
      { label: 'Devices', code: 'devices' },
      { label: 'Failed logins', code: 'report-failed-login' },
      { label: 'Anon logs', code: 'anon_logs' },
      { label: 'Authed logs', code: 'player_logs' },
      { label: 'Self Exclusion Queue', code: 'self-exclusion-queue' },
    ],
  },
  {
    label: 'Deposits',
    code: 'deposits',
    tabs: [
      { label: 'Ticker archive', code: 'deposit' },
      { label: 'Requests', code: 'report-deposit-request' },
      { label: 'Top-ups', code: 'top_ups' },
    ],
  },
  {
    label: 'Withdrawals',
    code: 'withdrawals',
    tabs: [
      { label: 'Ticker', code: 'withdrawticker' },
      { label: 'Ticker archive', code: 'withdraw' },
    ],
  },
  {
    label: 'Exemptions',
    code: 'exemptions-config',
    tabs: [],
  },
  {
    label: 'Metadata',
    code: 'metadata',
    tabs: [
      { label: 'Studios', code: 'game-studios' },
      { label: 'Providers', code: 'game-providers' },
      { label: 'Features', code: 'game-tags' },
      { label: 'Labels', code: 'game-labels' },
      { label: 'Game definitions', code: 'game-defs' },
    ],
  },
  {
    label: 'Scheduling',
    code: 'scheduling',
    tabs: [
      { label: 'Downtime', code: 'games-override' },
      { label: 'Commercials', code: 'commercial-game-overrides' },
      { label: 'Diamonds', code: 'GameDiamondGroupOverrides' },
      { label: 'Curation', code: 'gamecategoryscheduledjob' },
    ],
  },
  {
    label: 'Diagnostics',
    code: 'lotto-diagnostics',
    tabs: [
      { label: 'Future buys', code: 'future_buys' },
      { label: 'Summary', code: 'report-lotto' },
      { label: 'Lines', code: 'lotto_lines' },
      { label: 'API requests', code: 'eu_lotto_requests' },
    ],
  },
  {
    label: 'Deep links',
    code: 'deep-links',
    tabs: [
      { label: 'Manage', code: 'DeepLinks' },
      { label: 'Click tracking', code: 'player_links' },
    ],
  },
  {
    label: 'Learn pages',
    code: 'learn-pages',
    tabs: [
      { label: 'Articles', code: 'learn' },
      { label: 'Curation', code: 'learn-ordering' },
    ],
  },
  {
    label: 'Root',
    code: 'root',
    tabs: [
      { label: 'Sites', code: 'root-web-site' },
      { label: 'Assets', code: 'root-web-page' },
    ],
  },
  {
    label: 'Solutions',
    code: 'solutions',
    tabs: [
      { label: 'Settings', code: 'PaymentSolutions' },
      { label: 'Availability', code: 'solution-availability' },
    ],
  },
  {
    label: 'Gateways',
    code: 'gateways',
    tabs: [
      { label: 'Settings', code: 'PaymentGateways' },
      { label: 'Availability', code: 'gateway-availability' },
    ],
  },
  {
    label: 'Deposits',
    code: 'payments-deposits',
    tabs: [
      { label: 'Rules', code: 'deposit-action-rules' },
      { label: 'Amount options', code: 'fund-option' },
      { label: 'Amount groups', code: 'topup-option-buckets' },
    ],
  },
  {
    label: 'Addresses',
    code: 'addresses',
    tabs: [
      { label: 'Profiles', code: 'AddressProfiles' },
      { label: 'Providers', code: 'AddressProviders' },
    ],
  },
  {
    label: 'Currencies',
    code: 'currencies',
    tabs: [
      { label: 'Profiles', code: 'CurrencyProfiles' },
      { label: 'Forex', code: 'currency' },
    ],
  },
  {
    label: 'Hero Slides',
    code: 'hero-slides',
    tabs: [
      { label: 'Hero Slides', code: 'hero-slide' },
      { label: 'Hero Banners', code: 'hero-banner' },
    ],
  },
];
